const e=Object.freeze({UNABLE_TO_GENERATE_SIGNED_URL:"Unable to generate signed url",UNAVAILABLE_PRESIGNED_URL:"The presigned url is missing"});export{e as ERROR_MESSAGES};
//# sourceMappingURL=constants.js.map
